var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPiggyBankWithCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 928 928",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M801.163,279.3c-35.2-32.4-76-57.7-119.8-76.1c-5.7,8.6-12.2,16.7-19.6,24.1c-9.801,9.8-20.801,18.2-32.801,24.9 c12.7,4.2,24.9,9,36.601,14.5c11.899,5.6,16.5,20.2,9.899,31.6l0,0c-5.8,10.1-18.5,14.1-29,9.1c-79.8-37.7-168.899-30.6-208-24.7 c-11.5,1.7-22.5-5.6-25.199-16.9v-0.1c-3.101-12.8,5.5-25.5,18.5-27.5c7.1-1.1,15.699-2.2,25.3-3.1c-2.9-2.5-5.7-5.1-8.4-7.8 c-13.8-13.8-24.7-29.9-32.3-47.9c-0.8-1.9-1.6-3.9-2.3-5.8c-11.9,2-23.7,4.5-35.2,7.4c-67-39-147.4-39.1-195.2-34.4 c-20.8,2-33.1,24.2-24,43l40.5,83c-45,39.2-79,87.2-98.1,140.7l-49.4-0.2c-16.6-0.1-30.1,13.4-30.1,30V553.9 c0,11.199,6.2,21.399,16.1,26.6l64.1,33.4c26.8,73.899,82.3,137.3,155.5,181V893c0,19.3,15.7,35,35,35h89.8 c13.899,0,26.5-8.3,32.1-21l22.5-51.7c19.4,2.4,39.101,3.601,59.3,3.601c31.801,0,62.7-3,92.4-8.7V893c0,19.3,15.7,35,35,35h89.4 c12.899,0,24.8-7.1,30.899-18.5c47.601-89.4,99.3-179.1,137.5-272.7c19.3-47.399,26.3-97.7,22.101-146.8 C897.462,410.8,861.462,334.7,801.163,279.3z M263.963,465.4c-24.9,0-45-20.101-45-45c0-24.9,20.1-45,45-45s45,20.1,45,45 C308.962,445.3,288.863,465.4,263.963,465.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.863,233c13.7,5.4,28.7,8.4,44.4,8.4c7.699,0,15.199-0.7,22.399-2.1c30.601-5.7,57.101-23,74.8-47.1 c14.7-20,23.4-44.7,23.4-71.5c0.1-66.7-54-120.7-120.6-120.7c-66.7,0-120.7,54-120.7,120.7c0,17.3,3.6,33.7,10.2,48.6 C457.462,198.3,481.363,221.3,510.863,233z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBankWithCoin);
export default __webpack_public_path__ + "static/media/piggy-bank-with-coin.4c06d023.svg";
export { ForwardRef as ReactComponent };